import axios from 'axios'
import Api from '../services/Api'
import { ADD_PLACE, EDIT_PLACE, FETCH_ALL_PLACES, REMOVE_PLACE, SET_CURRENT_POSITION, SET_FILTER, SET_SELECTED_PLACE, SWITCH_DISPLAY_MODE } from './index'

const apiService = new Api()

const PLACE_POPULATE = 'populate[placecriteria][populate]=criteria&populate[type]=true&populate[user]=true'

const placePayload = (place) => ({
  name: place.name,
  favorite: !!place.favorite,
  fsPlaceId: place.fsPlaceId,
  coordinates: place.coordinates,
  city: place.city,
  country: place.country,
  type: place.type && typeof place.type === 'object' ? place.type.id : place.type,
})

export const switchDisplayMode = () => ({
  type: SWITCH_DISPLAY_MODE,
  payload: true
})

export const resetPlaces = () => ({
  type: FETCH_ALL_PLACES,
  payload: null
})

export const setCurrentPosition = (currentPosition) => ({
  type: SET_CURRENT_POSITION,
  payload: currentPosition
})

export const setSelectedPlace = (place) => ({
  type: SET_SELECTED_PLACE,
  payload: place
})

export const fetchAllUserPlaces = (currentPosition) => dispatch => {
  if (!localStorage.getItem('jwt')) {
    return {
      type: FETCH_ALL_PLACES,
      payload: null
    }
  }
  apiService.fetchAllUserPlaces()
    .then(res => {
      return dispatch({
        type: FETCH_ALL_PLACES,
        payload: res
      })
    })
}

export const addPlace = (place, listValues) => dispatch => {
  axios.post(
    process.env.REACT_APP_API_URL + '/api/places?' + PLACE_POPULATE,
    { data: placePayload(place) },
    apiService.getConfig()
  )
    .then(res => {
      const created = res.data && res.data.data ? res.data.data : res.data
      const newPlaceId = created.id
      Promise.all(
        listValues.map(v => axios.post(
          process.env.REACT_APP_API_URL + '/api/placecriterias?populate=criteria',
          { data: { value: v.value, criteria: v.idCriteria, place: newPlaceId } },
          apiService.getConfig()
        ).then(r => (r.data && r.data.data ? r.data.data : r.data)))
      ).then(pcs => {
        const coordinates = (created.coordinates || '').split(',')
        created.longitude = parseFloat(coordinates[1])
        created.latitude = parseFloat(coordinates[0])
        created.placecriteria = pcs
        dispatch({
          type: ADD_PLACE,
          payload: created
        })
      })
    })
}

const criteriaIdOf = (pc) => (pc.criteria && typeof pc.criteria === 'object' ? pc.criteria.id : pc.criteria)

export const editPlace = (place, listValues) => dispatch => {
  Promise.all(
    listValues.map(v => {
      const placeCriteria = (place.placecriteria || []).filter(pc => criteriaIdOf(pc) === v.idCriteria)
      if (placeCriteria.length === 1) {
        return axios.put(
          process.env.REACT_APP_API_URL + '/api/placecriterias/' + placeCriteria[0].documentId + '?populate=criteria',
          { data: { value: v.value } },
          apiService.getConfig()
        ).then(r => (r.data && r.data.data ? r.data.data : r.data))
      }
      return axios.post(
        process.env.REACT_APP_API_URL + '/api/placecriterias?populate=criteria',
        { data: { value: v.value, criteria: v.idCriteria, place: place.id } },
        apiService.getConfig()
      ).then(r => (r.data && r.data.data ? r.data.data : r.data))
    })
  ).then(res => {
    res.forEach(r => {
      const rCriteriaId = criteriaIdOf(r)
      place.placecriteria = (place.placecriteria || []).filter(pc => criteriaIdOf(pc) !== rCriteriaId)
      place.placecriteria.push(r)
    })
    dispatch({
      type: EDIT_PLACE,
      payload: place
    })
  })
}

export const removePlace = (place) => dispatch => {
  apiService.removePlace(place)
    .then(placeId => {
      dispatch({
        type: REMOVE_PLACE,
        payload: placeId
      })
    })
}

export const setFilter = (name, value) => ({
  type: SET_FILTER,
  payload: {
    name,
    value
  }
})
